<p-dialog
        header="Edit captions"
        [modal]="true"
        [(visible)]="dialogVisible"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true"
        (onHide)="close()"
        [style]="{ minWidth: '75vw' }"
>
    <div class="mb-4">
        <label class="font-semibold w-10rem mb-2">Failure Term: </label>
        <div class="flex flex-column gap-2 mt-2 w-6">
            <input type="text" pInputText placeholder="Failure term..." [(ngModel)]="failureTerm"/>
        </div>
    </div>
    <div class="mb-4">
        <label class="font-semibold w-10rem mb-2">Safety caption: </label>
        <div class="flex flex-column gap-2 mt-2">
            <p-editor [(ngModel)]="safetyCaption" [style]="{ height: '250px' }" />
        </div>
    </div>
    <div class="mb-4">
        <label class="font-semibold w-10rem mb-2">Cost caption: </label>
        <div class="flex flex-column gap-2 mt-2">
            <p-editor [(ngModel)]="costCaption" [style]="{ height: '250px' }" />
        </div>
    </div>

    <div class="flex justify-content-end gap-2">
        <p-button label="Cancel" severity="secondary"
                  (click)="close()"/>
        <p-button
                label="Save"
                [loading]="loading"
                (onClick)="save()"
        />
    </div>
</p-dialog>